export default __webpack_public_path__ + "static/media/group-3-img3.6969ba70.png";